import { translations as sharedTranslations } from '@football-kids/client-shared';
import { MODULE_RESOURCE } from '../type';

const fields = sharedTranslations.fields;

const translations = {
    // lib_inventory: {
    //     notification: {
    //         challenge_done: 'Wyzwanie ukończone!'
    //     }
    // },
    resources: {
        [MODULE_RESOURCE.ProductVariants]: {
            name: 'Wariant |||| Warianty',
            create: {
                title: 'Dodawanie wariantu'
            },
            edit: {
                title: 'Edycja wariantu'
            },
            list: {
                title: 'Warianty'
            },
            fields
        },
        [MODULE_RESOURCE.Products]: {
            name: 'Produkt |||| Produkty',
            create: {
                title: 'Dodawanie produktu'
            },
            edit: {
                title: 'Edycja produktu'
            },
            list: {
                title: 'Produkty'
            },
            fields: {
                ...fields,
                variantName: 'Wariant',
                type: 'Typ',
                product: 'Produkt',
                quantity: 'Ilość'
            }
        },
        [MODULE_RESOURCE.CustomerInventories]: {
            name: 'Produkt |||| Produkty',
            create: {
                title: 'Dodawanie produktu'
            },
            edit: {
                title: 'Edycja produktu'
            },
            list: {
                title: 'Magazyn'
            },
            fields: {
                ...fields,
                variantName: 'Wariant',
                type: 'Typ',
                product: 'Produkt',
                quantity: 'Ilość',
                'product.title': 'Produkt',
                'productVariant.title': "Wariant"
            }
        },
        [MODULE_RESOURCE.Orders]: {
            name: 'Zamówienie |||| Zamówienia',
            create: {
                title: 'Składanie zamówienia'
            },
            edit: {
                title: 'Edycja zamówienia'
            },
            list: {
                title: 'Zamówienia'
            },
            fields: {
                ...fields,
                createdAt: fields.createdDate,
                'invoice.vatNumber': 'NIP',
                'invoice.companyName': 'Nazwa firmy',
                paymentStatus: 'Opłacono',
                fulfillmentStatus: 'Wysłano',
                variantName: 'Wariant',
                type: 'Typ',
                product: 'Produkt',
                quantity: 'Ilość',
                'product.title': 'Produkt',
                'productVariant.title': "Wariant"
            }
        }
    }
};

export default translations;
